import React from 'react';
import DubbingContainer from '@src/containers/Dubbing';

const Dubbing = () => <DubbingContainer />;

export default Dubbing;
